export enum ReviewTargetType {
  DOCTOR = 'DOCTOR',
  PHARMACY = 'PHARMACY',
}

export enum EReviewType {
  NORMAL = 'NORMAL',
  BEST = 'BEST',
}

export enum MedicineType {
  Counselor = 'COUNSELOR',
  Dentist = 'DENTIST',
  Doctor = 'DOCTOR',
  OrientalDoctor = 'ORIENTAL_DOCTOR',
}

export class Review {
  constructor(
    private review: {
      id: number;
      title: string;
      content: string;
      likeCount: number;
      isLiked: boolean;
      isBlockedByUser: boolean;
      isCommentBlockedByUser: boolean;
      rating: number;
      createdAt: string;
      isPrivate: boolean;
      userId: number;
      writer: string;
      price: string | null;
      diagnosisCategoryName: string;
      tags: ReviewTag[];
      doctor: ReviewDiagnosisDoctor | null;
      comment: ReviewComment | null;
    },
  ) {}

  get id() {
    return this.review.id;
  }

  get isPrivate() {
    return this.review.isPrivate;
  }

  get userId() {
    return this.review.userId;
  }

  get isLiked() {
    return this.review.isLiked;
  }

  get title() {
    return this.review.title;
  }

  get content() {
    return this.review.content;
  }

  get writer() {
    return this.review.writer;
  }

  get rating() {
    return this.review.rating;
  }

  get comment() {
    return this.review.comment;
  }

  get likeCount() {
    return this.review.likeCount;
  }

  get tags() {
    return this.review.tags;
  }

  get price() {
    return this.review.price;
  }

  get createdAt() {
    return this.review.createdAt;
  }

  get diagnosisCategoryName() {
    return this.review.diagnosisCategoryName;
  }

  get doctor() {
    return this.review.doctor;
  }

  shouldNotDisplayed(currentUserId?: number) {
    if (!this.isPrivate) {
      return false;
    }

    return Number(currentUserId) !== Number(this.userId);
  }
}

export class ReviewTag {
  constructor(
    private tag: {
      reviewId: number;
      tagId: number;
      text: string;
    },
  ) {}

  get reviewId() {
    return this.tag.reviewId;
  }
  get tagId() {
    return this.tag.tagId;
  }
  get text() {
    return this.tag.text;
  }
}

export class ReviewComment {
  constructor(
    private reviewComment: {
      createdAt: string;
      content: string;
    },
  ) {}

  get createdAt() {
    return this.reviewComment.createdAt;
  }
  get content() {
    return this.reviewComment.content;
  }
}

export class ReviewDiagnosis {
  constructor(
    private reviewDiagnosis: {
      doctor: ReviewDiagnosisDoctor | null;
    },
  ) {}

  get doctor() {
    return this.reviewDiagnosis.doctor;
  }
}

export class ReviewDiagnosisDoctor {
  constructor(
    private reviewDiagnosisDoctor: {
      id: number;
      medicineType: MedicineType;
      name: string;
      profile: string;
    },
  ) {}

  get id() {
    return this.reviewDiagnosisDoctor.id;
  }
  get medicineType() {
    return this.reviewDiagnosisDoctor.medicineType;
  }
  get name() {
    return this.reviewDiagnosisDoctor.name;
  }
  get profile() {
    return this.reviewDiagnosisDoctor.profile;
  }

  getDoctorDisplayName() {
    if (this.medicineType === MedicineType.OrientalDoctor) {
      return `${this.name} 한의사`;
    }
    return `${this.name} 의사`;
  }
}

export interface GetRatingReviewFormProps {
  title: string;
  score: number;
  satisfactionText: string;
  onUpdateScore: (score: number) => void;
  onClickNextStatus: () => void;
}

export interface ReviewTagVo {
  id: string;
  text: string;
}

export interface GetSatisfactionReviewFormProps {
  score: number;
  satisfactionText: string;
  reviewDetail?: string;
  reviewTags: ReviewTagVo[];
  terms: string[];
  selectedReviewTagIds: string[];
  onSubmitReview: () => Promise<void>;
  onSelectReviewTag: (id: string) => void;
  onChangeReviewDetail: (value: string) => void;
  onOpenServiceTermsLink: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export enum ReviewTagExposure {
  ALWAYS = 'ALWAYS',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NONE = 'NONE',
}
